import { useEffect, useState } from 'react'

import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { PaymentForm, RESUME } from '../InfoFields'

export const CostsAndRetrat = (props) => {
  const { editValue, handleChange, edit, companies, id, handleChangeMultiple } = props
  const [tab, setTab] = useState(0)
  const [rows, setRows] = useState([])
  const [payments, setPayments] = useState([])
  const [payValues, setPayValues] = useState({
    totalGastos: 0,
    totalIngresos: 0,
    costoTotal: 0,
  })

  const {
    state: paymentDetail,
    setOpen: setOpenPaymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const listVerticalTabs = [
    {
      id: 0,
      title: 'Resumen',
    },
  ]

  const buildTable = (payments) => {
    const tableRows = []
    let totalGastos = 0
    let totalIngresos = 0
    const percent = parseFloat(`0.${editValue.cia_seguros.porcentaje_compulsa}`)

    if (percent > 0) {
      const company = companies.find((c) => c.id === editValue.cia_seguros_id)

      totalGastos = totalGastos + Number(editValue.cotizacion_restos) * percent

      tableRows.push({
        item: tableRows.length + 1,
        concepto: 'Comision compulsa',
        proveedor: company.nombre,
        monto: `$${Number(editValue.cotizacion_restos) * percent}`,
        tipo: 'Gasto',
      })
    }

    payments
      .filter((payment) => payment.tipo !== 'Pago vehículo')
      .forEach((payment) => {
        tableRows.push({
          item: tableRows.length + 1,
          concepto: payment.tipo,
          proveedor: payment.proveedor,
          monto: `$${payment.monto_total}`,
          tipo: payment.concepto_tipo,
        })

        if (payment.concepto_tipo === 'Ingreso') {
          totalIngresos = totalIngresos + Number(payment.monto_total)
        } else {
          totalGastos = totalGastos + Number(payment.monto_total)
        }
      })

    const total =
      Number(editValue.cotizacion_restos) +
      Number(totalGastos) -
      Number(editValue.cotizacion_retiro) -
      Number(totalIngresos)

    setPayValues({
      totalGastos: totalGastos,
      totalIngresos: totalIngresos,
      costoTotal: total,
    })

    setRows(tableRows)
  }

  const getPayments = async (id) => {
    await interfaces.vehicleInterface
      .getAllPayments(id)
      .then((res) => {
        setPayments(res.data)
        buildTable(res.data)
      })
      .catch(() => {
        buildTable([])
      })
  }

  const onClickRow = (data, index) => {
    if (data.concepto === 'Comision compulsa') return
    setOpenPaymentDetail(payments[index])
  }

  useEffect(() => {
    id ? getPayments(id) : buildTable([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getFactor = (name) => {
    const iva = 0.21
    const percepciones = editValue.cia_seguros?.percepciones || []

    const totalPerc = percepciones.reduce((acc, p) => acc + (Number(p.value) || 0) / 100, 0)

    return name === 'cotizacion_retiro' || name === 'cotizacion_retiro_neto'
      ? 1 + iva
      : 1 + iva + totalPerc
  }

  const handleCotizacionChange = (name, value) => {
    const factor = getFactor()
    let resto = editValue.cotizacion_restos
    let restoNeto = editValue.cotizacion_restos_neto

    if (name === 'cotizacion_restos') {
      resto = value
      restoNeto =
        value === '' || value == null ? '' : parseFloat((Number(value) / factor).toFixed(2))
    } else if (name === 'cotizacion_restos_neto') {
      restoNeto = value
      resto = value === '' || value == null ? '' : parseFloat((Number(value) * factor).toFixed(2))
      if (resto === 100.01) resto = 100
    }

    handleChange({
      cotizacion_restos: resto,
      cotizacion_restos_neto: restoNeto,
    })
  }

  const handleCotizacionBlur = (name) => {
    let resto =
      editValue.cotizacion_restos === '' || editValue.cotizacion_restos == null
        ? null
        : parseFloat(editValue.cotizacion_restos)

    let restoNeto =
      editValue.cotizacion_restos_neto === '' || editValue.cotizacion_restos_neto == null
        ? null
        : parseFloat(editValue.cotizacion_restos_neto)

    const factor = getFactor()

    if (name === 'cotizacion_restos') {
      resto = resto !== null ? parseFloat(resto.toFixed(2)) : null
      restoNeto = resto !== null ? parseFloat((resto / factor).toFixed(2)) : null
    } else if (name === 'cotizacion_restos_neto') {
      if (restoNeto !== null) {
        restoNeto = parseFloat(restoNeto.toFixed(2))
        resto = parseFloat((restoNeto * factor).toFixed(2))

        if (Math.abs(resto - 100.01) < 0.01) resto = 100
      }
    }

    handleChange({
      cotizacion_restos: resto,
      cotizacion_restos_neto: restoNeto,
    })
  }

  const handleCotizacionChange2 = (name, value) => {
    const factor = getFactor(name)
    let retiro = editValue.cotizacion_retiro
    let retiroNeto = editValue.cotizacion_retiro_neto

    if (name === 'cotizacion_retiro') {
      retiro = value
      retiroNeto =
        value === '' || value == null ? '' : parseFloat((Number(value) / factor).toFixed(2))
    } else if (name === 'cotizacion_retiro_neto') {
      retiroNeto = value
      retiro = value === '' || value == null ? '' : parseFloat((Number(value) * factor).toFixed(2))
      if (retiro === 99.99) retiro = 100
    }

    handleChange({
      cotizacion_retiro: retiro,
      cotizacion_retiro_neto: retiroNeto,
    })
  }

  const handleCotizacionBlur2 = (name) => {
    let retiro =
      editValue.cotizacion_retiro === '' || editValue.cotizacion_retiro == null
        ? null
        : parseFloat(editValue.cotizacion_retiro)

    let retiroNeto =
      editValue.cotizacion_retiro_neto === '' || editValue.cotizacion_retiro_neto == null
        ? null
        : parseFloat(editValue.cotizacion_retiro_neto)

    const factor = getFactor(name)

    if (name === 'cotizacion_retiro') {
      retiro = retiro !== null ? parseFloat(retiro.toFixed(2)) : null
      retiroNeto = retiro !== null ? parseFloat((retiro / factor).toFixed(2)) : null
    } else if (name === 'cotizacion_retiro_neto') {
      if (retiroNeto !== null) {
        retiroNeto = parseFloat(retiroNeto.toFixed(2))
        retiro = parseFloat((retiroNeto * factor).toFixed(2))

        if (Math.abs(retiro - 99.99) < 0.01) retiro = 100
      }
    }

    handleChange({
      cotizacion_retiro: retiro,
      cotizacion_retiro_neto: retiroNeto,
    })
  }

  useEffect(() => {
    if (editValue) {
      const factorRestos = getFactor()
      const factorRetiro = getFactor('cotizacion_retiro')

      let resto = parseFloat(editValue.cotizacion_restos) || null
      let restoNeto = parseFloat(editValue.cotizacion_restos_neto) || null

      if (resto && !restoNeto) {
        restoNeto = parseFloat((resto / factorRestos).toFixed(2))
      }

      let retiro = parseFloat(editValue.cotizacion_retiro) || null
      let retiroNeto = parseFloat(editValue.cotizacion_retiro_neto) || null

      if (retiro && !retiroNeto) {
        retiroNeto = parseFloat((retiro / factorRetiro).toFixed(2))
      }

      handleChange({
        cotizacion_restos: resto,
        cotizacion_restos_neto: restoNeto,
        cotizacion_retiro: retiro,
        cotizacion_retiro_neto: retiroNeto,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <div style={{ padding: '4rem' }}>
            <InputsWithoutValidate
              fields={RESUME(
                editValue,
                handleChange,
                edit,
                payValues,
                handleChangeMultiple,
                handleCotizacionChange,
                handleCotizacionChange2,
                handleCotizacionBlur,
                handleCotizacionBlur2
              )}
              spacing={2}
            />
            <div style={{ height: '15px' }} />
            {rows.length > 0 && (
              <BasicTable
                col={[
                  {
                    title: 'Item',
                    style: { width: '55px', cursor: 'pointer' },
                  },
                  {
                    title: 'Concepto',
                    style: { width: '300px', cursor: 'pointer' },
                  },
                  {
                    title: 'Proveedor',
                    style: { width: '100px', cursor: 'pointer' },
                  },
                  {
                    title: 'Monto',
                    style: { width: '120px', cursor: 'pointer' },
                  },
                  {
                    title: 'Tipo',
                    style: { width: '100px', cursor: 'pointer' },
                  },
                ]}
                size="small"
                rows={rows}
                onClickRow={onClickRow}
              />
            )}
          </div>
        )
      default:
        break
    }
  }

  return (
    <>
      <ContentWithSubTabs
        listVerticalTabs={listVerticalTabs}
        value={tab}
        setValue={setTab}
        children={renderTabs(tab)}
      />

      <DialogComponent
        open={paymentDetail.open}
        title={`Pago a proveedor #${paymentDetail.id}`}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={<InputsWithoutValidate fields={PaymentForm(paymentDetail)} spacing={2} />}
      />
    </>
  )
}
